import React, {Component} from 'react'
import CSSModules from 'react-css-modules'
// import {Row, Col} from 'react-flexbox-grid'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import {SlideDown} from 'react-slidedown'
import config from '../../config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  // SocialButtons,
  // GetStartedInput,
  AutocompleteSearch
} from '../../components'
import Styles from './Toolkit.css'

function NewlineText(props) {
  return <div>
    { props.text.split('\n\n').map((str, i) => <p key={'nltxt-'+i}>{str}</p>) }
  </div>
}

@CSSModules(Styles, {allowMultiple:true})
export default class Toolkit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      letter401kText: 'Dear Plan Administrator,\n\nI am an employee of [Company Name], and I participate in our company 401(k) plan. I am writing to inquire about socially just and sustainably invested fund options in the plan.\n\nI am concerned about the financial and moral risks associated with investing my retirement savings in fail to uphold values of gender equality, workplace equity, racial justice, and LGBTQ+ inclusion. A growing body of research indicates that companies that prioritize diversity, equity, and inclusion tend to outperform those that do not, both financially and in long-term risk management.\n\nI believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find information about the gender equity, workplace diversity, racial justice, and LGBTQ+ inclusion practices of the companies held within our plan’s investment options? Does our retirement plan offer any funds that are explicitly aligned with social justice?\n\nSocially responsible investing is no longer just an ethical consideration – it is a material factor in assessing financial well-being. The Department of Labor has stated that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be considered when fulfilling fiduciary duties.\n\nThere is an online resource, SocialJusticeFunds.org, which evaluates thousands of mutual funds and ETFs for their performance on gender equality, corporate diversity disclosures, racial justice, and LGBTQ+ equity. If none of our current plan options meet these criteria, this tool could help identify suitable socially just investment funds that could be added to our plan.\n\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you. \n\nBest,\n\n[Your Name]\n\n[Your contact information (company department, email, phone)]\n\n',
      letterAMText: 'Dear Fund Manager,\n\nI am a client of [Company Name], and I am writing to inquire about socially just and sustainably invested fund options offered by your company.\n\nI am increasingly concerned about the financial and ethical risks associated with investing in companies that fail to uphold values of gender equity, workplace diversity, racial justice, and LGBTQ+ equity. A growing body of research indicates that companies that prioritize diversity, equity, and inclusion tend to outperform those that do not, both financially and in long-term risk management.\n\nCan you please tell me how I can find out how your company’s funds perform on measures of gender equity, workplace diversity, racial justice, and LGBTQ+ equity? Does your firm offer any funds that explicitly integrate these social justice criteria?\n\nSocially responsible investing is not just an ethical preference – it is a material factor in assessing risk and long-term financial health. The Department of Labor has stated that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be considered when making fiduciary decisions.\n\nThere is an online resource, SocialJusticeFunds.org, that analyzes thousands of mutual funds and ETFs based on racial justice, gender equality, corporate diversity disclosures, and LGBTQ+ equity performance. If your company’s funds are not yet evaluated, I encourage you to review and consider alignment with this growing movement toward equitable, social justice-oriented investing.\n\nThank you in advance for your time and consideration. I appreciate your attention to this important issue and look forward to hearing from you. \n\nBest,\n\n[Your Name]\n\n[Your contact information (email, phone)]',
      copied: false,
      showSection4: null,
      showSection6: null,
      letter401k: true,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  onCopy = () => {
    this.setState({copied: true});
  };

  render() {
    const title = 'Social Justice Funds Action Toolkit'
    const description = 'Use the Social Justice Funds Action Toolkit to make a change and move your money.'
    const url = config.domain + config.routes.toolkit
    // const message = 'Action toolkit to move your money'
    //
    const iconClipboardTarget = require( '../../../static/images/toolkit/clipboard-target.png' )
    const imgStandingWoman = require( '../../../static/images/toolkit/Woman_building.png' )
    const imgPeopleFuture = require( '../../../static/images/toolkit/People_future.png' )
    const iconSearch = require( '../../../static/images/toolkit/search.png' )
    const iconPhone = require( '../../../static/images/toolkit/phone.png' )
    const iconDollar = require( '../../../static/images/toolkit/dollar.png' )
    //
    return (
      <div styleName='page'>
        {container.helmet(title, description, url)}

        <ContainerDivs>
          <header styleName='toolkit-header'>
            <div styleName='toolkit-header-inner'>
              <div styleName='toolkit-header-label-wrap'>
                <div styleName='toolkit-header-label'>
                  Action toolkit
                </div>
              </div>
              <h1 styleName='toolkit-title'>
                How to invest in a socially just future
              </h1>
            </div>
            <img
              src={iconClipboardTarget}
              role='presentation'
              styleName='toolkit-header-icon'
            />
          </header>
        </ContainerDivs>

        <ContainerDivs>

          { /*
              SECTION 1
          */ }
          <section styleName='toolkit-section-1'>
            <div>
              <h2 styleName='toolkit-section-h2'>
                This is the moment to stand up for social justice
              </h2>
              <p styleName='toolkit-section-p'>
                In 2025, some companies have bowed to political pressure and retreated from commitments to advancing social justice in the workplace. They’ve rolled back their Diversity, Equity, and Inclusion (DEI) programs and distanced themselves from pledges to advancing racial justice. But consumers have quickly spoken up. They used their economic power to support brands aligned with justice and boycotted those that weren’t. By aligning their investments with their values, retirement investors can help drive continued corporate accountability to social justice. 
              </p>
            </div>
            <img
              src={imgStandingWoman}
              role='presentation'
              styleName='toolkit-section-1-img'
            />
          </section>

          { /*
              SECTION 2
          */ }
          <section styleName='toolkit-section-2'>
            <img
              src={imgPeopleFuture}
              role='presentation'
             styleName='toolkit-section-2-img'
            />
            <div>
              <h2 styleName='toolkit-section-h2'>
                From savings to social change
              </h2>
              <p styleName='toolkit-section-p'>
                It’s not always clear whether the companies in your retirement portfolio are advancing social justice issues like gender equality, racial justice, workplace equity, and LGBTQ+ rights – or are working against it. By using this Social Justice Funds toolkit, you can see if your savings are invested in companies undermining social justice, and find investment options that support a just future while <Link to='https://www.asyousow.org/reports/2023-capturing-the-diversity-benefit' title='Capturing the Diversity Benefit'>maximizing returns.</Link> 
              </p>
            </div>
          </section>

          { /*
              SECTION 3
          */ }
          <section styleName='toolkit-section-3'>
            <h2 styleName='toolkit-section-3-h2'>
              We can help build a more equitable world by aligning our investments with social justice. 
            </h2>
          </section>

          { /*
              SECTION 4
          */ }
          <section styleName='toolkit-section-4'>
            <div styleName='toolkit-section-steps-123-number'>
              1
            </div>
            <div styleName='toolkit-section-steps-123-content'>
              <h3 styleName='toolkit-section-steps-123-h3'>
                Find your funds
              </h3>
              <p styleName='toolkit-section-steps-123-p'>
                Before finding out what companies in your portfolio are falling behind on social justice issues, first login to your investment account, and write down the list of funds you are currently invested in. You will use this list in the next step.
              </p>
              <div styleName='toolkit-section-steps-123-buttons'>
                <button
                  onClick={() => {
                    const n = this.state.showSection4 === 1 ? null : 1
                    this.setState({showSection4: n})
                  }}
                >
                  <span styleName={'toolkit-section-steps-123-button ' + (this.state.showSection4 === 1 ? 'active' : '')}>
                    Where are my funds?
                  </span>
                </button>
                <button
                  onClick={() => {
                    const n = this.state.showSection4 === 2 ? null : 2
                    this.setState({showSection4: n})
                  }}
                >
                  <span styleName={'toolkit-section-steps-123-button ' + (this.state.showSection4 === 2 ? 'active' : '')}>
                    Invested in a 401(k)?
                  </span>
                </button>
              </div>
              <SlideDown>
                { this.state.showSection4 && this.state.showSection4 === 1 ?
                    <div styleName='toolkit-section-slidedown-content'>
                      <p styleName='toolkit-section-slidedown-p'>
                        Log in to your 401(k) platform or brokerage account to see which mutual funds you're invested in. If you're having difficulty locating the names of your funds, contact your investment advisor or the customer support team of your investment platform or institution for assistance.
                      </p>
                    </div> : null
                }
              </SlideDown>
              <SlideDown>
                { this.state.showSection4 && this.state.showSection4 === 2 ?
                    <div styleName='toolkit-section-slidedown-content'>
                      <p styleName='toolkit-section-slidedown-p'>
                        Over 100 million employees across the U.S. have over $10 trillion invested in retirement savings, but very few know which companies they are funding with their retirement dollars. Using our <Link to='https://investyourvalues.org/action-center/employees' title='Five steps to a sustainable retirement plan'><span styleName='span-link-on-pink'>employee 401(k) toolkit</span></Link>, you will learn how to lower your financial risks from unsustainable investments and maybe even help your co-workers do the same.
                      </p>
                    </div> : null
                }
              </SlideDown>
            </div>
            <img
              src={iconSearch}
              role='presentation'
              styleName='toolkit-section-steps-123-icon'
            />
          </section>

          { /*
              SECTION 5
          */ }
          <section styleName='toolkit-section-5'>
            <div styleName='toolkit-section-steps-123-number'>
              2
            </div>
            <div styleName='toolkit-section-steps-123-content'>
              <h3 styleName='toolkit-section-steps-123-h3'>
                Know what you own
              </h3>
              <p styleName='toolkit-section-steps-123-p'>
                Check to see if your investments are aligned with social justice. Use your investment list from step 1 to find your fund grades. You can search for mutual funds and exchange-traded funds (ETFs) by name, ticker, or asset manager. Our database covers 5,000 stock funds available in the U.S.
              </p>
              <div styleName='toolkit-section-steps-123-search'>
                <AutocompleteSearch />
              </div>
            </div>
            <img
              src={iconPhone}
              role='presentation'
              styleName='toolkit-section-steps-123-icon-phone'
            />
          </section>

          { /*
              SECTION 6
          */ }
          <section styleName='toolkit-section-6'>
            <div styleName='toolkit-section-steps-123-number'>
              3
            </div>
            <div styleName='toolkit-section-steps-123-content'>
              <h3 styleName='toolkit-section-steps-123-h3'>
                Take action
              </h3>
              <p styleName='toolkit-section-steps-123-p'>
                If your investments are exposed to companies falling behind on social justice, now is the time to sort and compare just alternatives. You can sort by performance and see how funds score on other issues, like climate change. Once you have a found funds that meet your investing circumstances, you can talk to your financial advisor or retirement plan administrator to align your investments with social justice.
              </p>
              <div styleName='toolkit-section-steps-123-buttons'>
                <Link to={config.routes.clean} title='Top rated funds'>
                  <span styleName='toolkit-section-steps-123-button'>
                    Top rated funds
                  </span>
                </Link>
                <button
                  onClick={() => {
                    const n = this.state.showSection6 === 1 ? null : 1
                    this.setState({
                      showSection6: n,
                      copied: false
                    })
                  }}
                >
                  <span styleName={'toolkit-section-steps-123-button ' + (this.state.showSection6 === 1 ? 'active' : '')}>
                    Send a letter
                  </span>
                </button>
              </div>
              <SlideDown>
                { this.state.showSection6 && this.state.showSection6 === 1 ?
                    <div styleName='toolkit-section-slidedown-content'>
                      <p styleName='toolkit-section-slidedown-p'>
                        Write a letter to your 401(k) plan administrator,
                        or to your fund manager directly. You can copy the
                        text below and update to fit your needs.
                      </p>
                      <div styleName='letter-select-btn-wrap'>
                        <button
                          onClick={() => {
                            this.setState({
                              letter401k: !this.state.letter401k,
                              copied: false
                            })
                          }}
                          styleName='letter-select-btn'
                        >
                          <span>
                            401(k) admin&nbsp;&nbsp;
                          </span>
                          <LinkIcon nospace faclass={'fa-toggle-' + (this.state.letter401k ? 'off' : 'on')}/>
                          <span>
                            &nbsp;&nbsp;Fund manager
                          </span>
                        </button>

                        <CopyToClipboard
                          onCopy={() => { this.setState({copied: true}) }}
                          text={this.state.letter401k ? this.state.letter401kText : this.state.letterAMText}
                        >
                          <button styleName='letter-select-btn'>
                            { this.state.copied ?
                                null :
                                <span><i className='fa fa-files-o'/>&nbsp;&nbsp;&nbsp;</span>
                            }
                            { this.state.copied ?
                                'Copied!' :
                                'Copy to clipboard'
                            }
                          </button>
                        </CopyToClipboard>
                      </div>

                      <div>
                        { this.state.letter401k ?
                            <div>
                              <p>
                                Letter to employer-offered
                                retirement plan manager:
                              </p>
                              <blockquote styleName='letter-blckqt'>
                                <NewlineText text={this.state.letter401kText} />
                              </blockquote>
                            </div> :
                            <div>
                              <p>
                                Letter to mutual fund manager:
                              </p>
                              <blockquote styleName='letter-blckqt'>
                                <NewlineText text={this.state.letterAMText} />
                              </blockquote>
                            </div>
                        }
                      </div>
                    </div> : null
                }
              </SlideDown>
            </div>
            <img
              src={iconDollar}
              role='presentation'
              styleName='toolkit-section-steps-123-icon'
            />
          </section>


        </ContainerDivs>
      </div>
    )
  }
}
